import $ from 'jquery';

import enquire from 'enquire.js'


let itemIndex = $('.tabs-jk__item-active').index();

enquire.register("screen and (max-width:766px)", {
    match : function() {

        $( '.js-tab-transform').addClass('dropdown-box');

        $('.tabs-jk__item-active').addClass('js-dropdown-box-trigger');

        $( '.js-tab-transform li:not(.tabs-jk__item-active)' ).wrapAll( "<ul class='js-dropdown-box-target link-box tabs-jk-reset' />");
    },
    unmatch : function() {

        $( '.js-tab-transform').removeClass('dropdown-box');

        $('.tabs-jk__item-active').removeClass('js-dropdown-box-trigger');

        $( '.js-tab-transform li:not(.tabs-jk__item-active)' ).unwrap();

        $('.tabs-jk li').each(function(){

            let elIndex = $(this).index();

            if (elIndex === itemIndex) {

                $('.tabs-jk__item-active').insertBefore($(this));
            }

        });



    },
});





